var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7416_1653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3668 2.63342C11.8552 -0.877483 6.14425 -0.877483 2.6326 2.63342C-0.877533 6.14433 -0.877533 11.8567 2.6326 15.3676C4.38842 17.1227 6.69424 17.9999 9.0001 17.9999C11.306 17.9999 13.611 17.1227 15.3668 15.3676C18.8777 11.8568 18.8777 6.14433 15.3668 2.63342ZM12.7136 11.6534C13.0069 11.9468 13.0069 12.421 12.7136 12.7144C12.5672 12.8607 12.3752 12.9343 12.1831 12.9343C11.991 12.9343 11.7989 12.8607 11.6525 12.7144L9.00006 10.0611L6.34832 12.7136C6.20126 12.8599 6.00915 12.9335 5.81781 12.9335C5.62573 12.9335 5.43362 12.8599 5.2873 12.7136C4.99392 12.4202 4.99392 11.9453 5.2873 11.6526L7.93904 9.00015L5.28656 6.34766C4.99318 6.05429 4.99318 5.57932 5.28656 5.28668C5.5792 4.9933 6.05417 4.9933 6.34754 5.28668L9.00003 7.93916L11.6525 5.28668C11.9459 4.9933 12.4201 4.9933 12.7135 5.28668C13.0069 5.57932 13.0069 6.05429 12.7135 6.34766L10.061 9.00015L12.7136 11.6534Z",
    fill: "#E60000",
    fillOpacity: 0.81
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7416_1653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCrossIcon);
export default __webpack_public_path__ + "static/media/redCrossIcon.a93f0895506b57f0c4d660529691235b.svg";
export { ForwardRef as ReactComponent };